export default __webpack_public_path__ + "static/media/GA.2773008d.png";